import React, {useEffect, useState} from 'react'
import {Dialog} from "primereact/dialog";
import 'primereact/dialog/dialog.min.css';


interface CustomDialogPropsI {
    header: string,
    dialogSize?: string
    component: any,
    onDialogHide: Function,
    visible: any,
    headerClass?: string,
    dismissableMask?:boolean
}

export const CustomDialog = ({component, header,onDialogHide, visible, dialogSize = 'md-dialog', headerClass , dismissableMask}: CustomDialogPropsI) => {
    useEffect(() => {
        if (visible) {
            document.body.classList.add("scroll-off");
        }
        return () => {
            document.body.classList.remove("scroll-off");
        };
    }, [visible]);
    
    return (
        <Dialog header="" visible={visible} className={dialogSize} onHide={() => onDialogHide(true)} dismissableMask={dismissableMask}>
            <div className={headerClass? headerClass+' form-heading col-12 ' : 'form-heading col-12' }>{header}</div>
            {component}
        </Dialog>
    )
}


